;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import { useEffect, useState } from 'react';
import { Button, ModalBody, ModalFooter } from 'reactstrap';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { orderBy } from 'lodash';

import capitalizeFirstLetter from '../../../utils/capitalizeFirstLetter';
import { getCandidate, saveCandidate } from '../../../api/candidate';
import { useUser } from '../../../contexts/UserContext';
import { logSentryError } from '../../../utils/logSentry';
import FormAlert from '../../forms/FormAlert';
import laborRegimeNodes, { laborRegimeOptions } from '../../../utils/carerix/dataNodes/labor-regime';
import FormikMultiSelectInput from '../../forms/inputs/FormikMultiSelectInput';
import { Dictionaries } from '../../../i18n/i18n-config';
import { useParams } from 'next/navigation';
import { getI18nUtils } from '../../../i18n/i18n-utils';

export const validationSchema = yup.object({
  laborRegime: yup.array().of(yup.string().oneOf(laborRegimeNodes, 'input_invalid')),
});

type JobPreferenceInputs = yup.InferType<typeof validationSchema>;

const initialValues: JobPreferenceInputs = { laborRegime: [] };

type Props = {
  dictionary: Partial<Dictionaries>;
  next: () => void;
  prev: () => void;
};

function ProfileModalLaborRegime({ next, prev, dictionary }: Props) {
  const { formatMessage } = getI18nUtils(dictionary);
  const { locale } = useParams();
  const { candidate, setCandidate } = useUser();
  const [alert, setAlert] = useState<{
    type: 'success' | 'warning' | 'danger';
    message: string;
  } | null>(null);

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (values, actions) => {
      try {
        const data = { jobPreferences: { laborRegime: values.laborRegime } };
        await saveCandidate(data, 'acquaintance');
        // "silent" refresh of context
        const c = await getCandidate();
        setCandidate(c);
        actions.setSubmitting(false);
        actions.resetForm();
        next();
      } catch (e: any) {
        setAlert({ type: 'danger', message: 'internal-server-error' });
        actions.setSubmitting(false);
        logSentryError(e);
      }
    },
  });

  useEffect(() => {
    const { laborRegime } = candidate?.jobPreferences || {};
    formik.setValues({ laborRegime: laborRegime || initialValues.laborRegime });
  }, [candidate]);

  const getOptions = (nodes: any[]) =>
    orderBy(
      nodes.map((dl) => ({
        value: dl.value,
        label: capitalizeFirstLetter(dl.labels.find(({ language }) => language === locale)?.label),
      })),
      ['label']
    );
  const laborRegimeSelect = getOptions(laborRegimeOptions);

  const { handleSubmit, isSubmitting } = formik;

  return (
    <>
      <ModalBody>
        <div className="py-4">
          <h2 className="d-block mb-3">{formatMessage({ id: 'profile_form_regime_title' })}</h2>

          <FormikMultiSelectInput
            dictionary={dictionary}
            disabled={isSubmitting}
            className="mb-3"
            formik={formik}
            name="laborRegime"
            intlKey="candidate_expectations_regime"
            options={laborRegimeSelect}
          />
        </div>
      </ModalBody>
      <ModalFooter>
        <FormAlert dictionary={dictionary} className="flex-grow-1 mb-2" alert={alert} />
        <Button disabled={isSubmitting} color="primary" className="mt-5 w-100" onClick={() => handleSubmit()}>
          {formatMessage({ id: 'next' })}
        </Button>
        <Button disabled={isSubmitting} color="white" className="mt-3 mx-auto d-block" onClick={() => prev()}>
          {formatMessage({ id: 'previous' })}
        </Button>
      </ModalFooter>
    </>
  );
}

export default ProfileModalLaborRegime;
